import { createFileRoute } from "@tanstack/react-router";
import { MoneyScreen } from "../screens/staff/MoneyScreen.tsx";

/** `/sysadmin/money`: plans and revenue, from list prices. */
export const Route = createFileRoute("/_staff/sysadmin/money")({
  component: MoneyScreen,
});
